import { stringCapitalize } from "./stringCapitalize";

export const columnSortingMessage = (sortingColumnData, pageName) => {
  return (
    "The " +
    stringCapitalize(sortingColumnData[0]?.sortedColumn) +
    " " +
    "column " +
    " is already sorted on " +
    (sortingColumnData[0]?.pageName === pageName ? "" : "the ") +
    (sortingColumnData[0]?.pageName === pageName
      ? "this"
      : sortingColumnData[0]?.pageName) +
    " page"
  );
};
